import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export abstract class HttpBaseService {

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }),
    params: null,
  };

  constructor(protected http: HttpClient) { }
  /*
  protected get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, this.httpOptions)
      .pipe(catchError(this.handleError<T>(url)));
  }
  */

  protected get<T>(url: string, params?: HttpParams): Observable<T> {
    if(params) {
      this.httpOptions.params = params;
    }
    return this.http.get<T>(url, this.httpOptions)
      .pipe(catchError(this.handleError<T>(url)));
  }

  protected post<T>(url: string, item: any): Observable<T> {
    return this.http.post<T>(url, item, this.httpOptions)
      .pipe(catchError(this.handleError<T>(url)));
  }

  protected put<T>(url: string, item: any): Observable<T> {
    return this.http.put<T>(url, item, this.httpOptions)
      .pipe(catchError(this.handleError<T>(url)));
  }

  protected delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, this.httpOptions)
      .pipe(catchError(this.handleError<T>(url)));
  }

  private handleError<T>(operation = 'operation') {
    return (error: any): Observable<T> => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Client-Side Error: ${error.error.message}\n`;
      } else {
        // server-side error
        errorMessage = `Server-Side Error Code: ${error.status}\nMessage: ${error.message}\n`;
      }
      console.error(`[${operation}] failed: ${errorMessage}`, error);
      return throwError(error);
    };
  }
}

